import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Layout/Navbar';
import AdminLayout from './components/Layout/AdminLayout';
import UniversityLayout from './components/Layout/UniversityLayout';
import Login from './pages/Login';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import UniversityDashboard from './components/Dashboard/UniversityDashboard';
import CaseList from './pages/CaseList';
import CaseDetail from './pages/CaseDetail';
import NewCase from './pages/NewCase';
import UserManagement from './pages/UserManagement';
import ManageApplyFor from './pages/ManageApplyFor';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div className="loading-container"><div className="spinner"></div></div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function AdminRoute({ children }) {
  const { user, isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div className="loading-container"><div className="spinner"></div></div>;
  }
  if (!isAuthenticated || user?.role !== 'facts_admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppContent() {
  const { isAuthenticated, user } = useAuth();
  const isAdmin = isAuthenticated && user?.role === 'facts_admin';

  return (
    <>
      
      <main>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                {user?.role === 'facts_admin' ? (
                  <AdminDashboard />
                ) : (
                  <UniversityLayout><UniversityDashboard user={user} /></UniversityLayout>
                )}
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                {user?.role === 'facts_admin' ? (
                  <AdminDashboard />
                ) : (
                  <UniversityLayout><UniversityDashboard user={user} /></UniversityLayout>
                )}
              </ProtectedRoute>
            }
          />
          <Route path="/cases" element={
            <ProtectedRoute>
              {isAdmin ? <AdminLayout><CaseList /></AdminLayout> : <UniversityLayout><CaseList /></UniversityLayout>}
            </ProtectedRoute>
          } />
          <Route path="/cases/new" element={
            <AdminRoute>
              <AdminLayout><NewCase /></AdminLayout>
            </AdminRoute>
          } />
          <Route path="/cases/:id" element={
            <ProtectedRoute>
              {isAdmin ? <AdminLayout><CaseDetail /></AdminLayout> : <UniversityLayout><CaseDetail /></UniversityLayout>}
            </ProtectedRoute>
          } />
          <Route path="/universities" element={
            <AdminRoute>
              <AdminLayout><UserManagement /></AdminLayout>
            </AdminRoute>
          } />
          <Route path="/manage-apply-for" element={
            <AdminRoute>
              <AdminLayout><ManageApplyFor /></AdminLayout>
            </AdminRoute>
          } />
          <Route path="/users" element={
            <AdminRoute>
              <AdminLayout><UserManagement /></AdminLayout>
            </AdminRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ErrorBoundary><AppContent /></ErrorBoundary>
    </AuthProvider>
  );
}
